import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container, Paper, Typography, CircularProgress, Grid, Divider } from '@mui/material';
import { API_URL } from '../config/api';

const Row = ({ label, value }) => (
  <Grid container spacing={1} sx={{ mb: 1 }}>
    <Grid item xs={12} sm={4}>
      <Typography variant="body2" color="text.secondary"><strong>{label}</strong></Typography>
    </Grid>
    <Grid item xs={12} sm={8}>
      <Typography variant="body2">{value || '-'}</Typography>
    </Grid>
  </Grid>
);

const ResignationSharedView = () => {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const run = async () => {
      try {
        const res = await fetch(`${API_URL}/offboarding/resignation/shared/${encodeURIComponent(token)}`);
        const json = await res.json();
        if (!res.ok || !json.success) {
          setError(json.error || 'Failed to load resignation');
        } else {
          setData(json.data);
        }
      } catch (e) {
        setError('Failed to load resignation');
      } finally {
        setLoading(false);
      }
    };
    run();
  }, [token]);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>Resignation Form</Typography>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error">{error}</Typography>
        ) : (
          <Box>
            <Row label="Employee Name" value={data.name} />
            <Row label="Employee ID" value={data.employeeId} />
            <Row label="Department" value={data.department} />
            <Row label="Designation" value={data.designation} />
            <Divider sx={{ my: 2 }} />
            <Row label="Reason for Resignation" value={data.reasonForResignation === 'Other' ? `${data.reasonForResignation} - ${data.otherReason || ''}` : data.reasonForResignation} />
            <Row label="Thinking Duration" value={data.thinkingDuration} />
            <Row label="Incidents Led To Decision" value={data.incidentsLedToDecision} />
            {data.scenarioExplanation && <Row label="Scenario Explanation" value={data.scenarioExplanation} />}
            <Divider sx={{ my: 2 }} />
            <Row label="Discussion Preference" value={data.discussionPreference} />
            <Row label="Date of Resignation" value={data.dateOfResignation ? new Date(data.dateOfResignation).toLocaleDateString() : ''} />
            <Row label="Proposed Last Working Day" value={data.proposedLastWorkingDay ? new Date(data.proposedLastWorkingDay).toLocaleDateString() : ''} />
            <Row label="Reporting Manager" value={data.reportingManager} />
            <Row label="Unit Head" value={data.unitHead} />
            <Divider sx={{ my: 2 }} />
            <Row label="Final Comments" value={data.finalComments} />
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default ResignationSharedView;

